import { orderDomainStore, journeyDomainStore } from '@vista/omnichannel-components-domain'

export function resetBookingStore(): void {
    orderDomainStore.reset()
    journeyDomainStore.reset()
}
